import styled from 'styled-components'

export const Container = styled.div`
  * {
    box-sizing: border-box !important;
  }

  display: ${({ show }: { show: boolean }) => (show ? 'block' : 'none')};

  .scroll {
    transform: translate(0px, 0px) !important;
  }
`
